export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_CURRENT_USER_UI_FLAGS: 'SET_CURRENT_USER_UI_FLAGS',
  SET_EMBEDDING: 'SET_EMBEDDING',
  SET_CURRENT_ACCOUNT: 'SET_CURRENT_ACCOUNT',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_CONV_LIST_NEXT_REFRESH_AT: 'SET_CONV_LIST_NEXT_REFRESH_AT',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  CHANGE_CHAT_SORT_FILTER: 'CHANGE_CHAT_SORT_FILTER',
  SET_CAMPAIGN_FILTER: 'SET_CAMPAIGN_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',
  SET_CONVERSATION_LAST_SEEN: 'SET_CONVERSATION_LAST_SEEN',
  SET_LAST_MESSAGE_ID_IN_SYNC_CONVERSATION: 'SET_LAST_MESSAGE_ID_FOR_SYNC_CONVERSATION',
  SET_MESSAGE_UI_FLAG: 'SET_MESSAGE_UI_FLAG',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  REMOVE_CONVERSATION: 'REMOVE_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  UPDATE_MESSAGE_UNREAD_COUNT: 'UPDATE_MESSAGE_UNREAD_COUNT',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',
  UPDATE_CONVERSATION_LAST_ACTIVITY: 'UPDATE_CONVERSATION_LAST_ACTIVITY',
  SET_MISSING_MESSAGES: 'SET_MISSING_MESSAGES',

  SET_ALL_ATTACHMENTS: 'SET_ALL_ATTACHMENTS',
  ADD_CONVERSATION_ATTACHMENTS: 'ADD_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION_ATTACHMENTS: 'DELETE_CONVERSATION_ATTACHMENTS',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOX_ITEM: 'SET_INBOX_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',
  SET_INBOXES_META: 'SET_INBOXES_META',

  // Accounts/Subaccounts
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  SET_SUBACCOUNTS_UI_FLAG: 'SET_SUBACCOUNTS_UI_FLAG',
  SET_SUBACCOUNTS: 'SET_SUBACCOUNTS',  

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',
  UPDATE_SINGLE_AGENT_PRESENCE: 'UPDATE_SINGLE_AGENT_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Agent Bot Management
  SET_AGENT_BOT_MANAGEMENT_UI_FLAG: 'SET_AGENT_BOT_MANAGEMENT_UI_FLAG',
  SET_AGENT_BOT_MANAGEMENT: 'SET_AGENT_BOT_MANAGEMENT',
  ADD_AGENT_BOT_MANAGEMENT: 'ADD_AGENT_BOT_MANAGEMENT',
  EDIT_AGENT_BOT_MANAGEMENT: 'EDIT_AGENT_BOT_MANAGEMENT',
  DELETE_AGENT_BOT_MANAGEMENT: 'DELETE_AGENT_BOT_MANAGEMENT',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Product Labels
  SET_PRODUCT_LABEL_UI_FLAG: 'SET_PRODUCT_LABEL_UI_FLAG',
  SET_PRODUCT_LABELS: 'SET_PRODUCT_LABELS',
  ADD_PRODUCT_LABEL: 'ADD_PRODUCT_LABEL',
  EDIT_PRODUCT_LABEL: 'EDIT_PRODUCT_LABEL',
  DELETE_PRODUCT_LABEL: 'DELETE_PRODUCT_LABEL',

  // Topic Labels
  SET_TOPIC_LABEL_UI_FLAG: 'SET_TOPIC_LABEL_UI_FLAG',
  SET_TOPIC_LABELS: 'SET_TOPIC_LABELS',
  ADD_TOPIC_LABEL: 'ADD_TOPIC_LABEL',
  EDIT_TOPIC_LABEL: 'EDIT_TOPIC_LABEL',
  DELETE_TOPIC_LABEL: 'DELETE_TOPIC_LABEL',

  // Concurrent Labels
  SET_CONCURRENT_LABEL_UI_FLAG: 'SET_CONCURRENT_LABEL_UI_FLAG',
  SET_CONCURRENT_LABELS: 'SET_CONCURRENT_LABELS',
  ADD_CONCURRENT_LABEL: 'ADD_CONCURRENT_LABEL',
  EDIT_CONCURRENT_LABEL: 'EDIT_CONCURRENT_LABEL',
  DELETE_CONCURRENT_LABEL: 'DELETE_CONCURRENT_LABEL',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',
  SET_INTEGRATION_ENABLED: 'SET_INTEGRATION_ENABLED',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',
  
  // Assistent
  SET_ASSISTENT_UI_FLAG: 'SET_ASSISTENT_UI_FLAG',
  SET_ASSISTENT: 'SET_ASSISTENT',
  ADD_ASSISTENT: 'ADD_ASSISTENT',
  DELETE_ASSISTENT: 'DELETE_ASSISTENT',
  UPDATE_ASSISTENT: 'UPDATE_ASSISTENT',
  SET_ASSISTENT_TEMP_FILES: 'SET_ASSISTENT_TEMP_FILES',
  SET_ASSISTENT_TEMP_VECTOR_STORE_ID: 'SET_ASSISTENT_TEMP_VECTOR_STORE_ID',

  // Public knowledge bases
  SET_PUBLIC_KNOWLEDGE_BASES_UI_FLAG: 'SET_PUBLIC_KNOWLEDGE_BASES_UI_FLAG',
  SET_PUBLIC_KNOWLEDGE_BASES: 'SET_PUBLIC_KNOWLEDGE_BASES',


  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  SET_CONTACTS: 'SET_CONTACTS',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',

  // Opportunities
  SET_OPPORTUNITIES_UI_FLAG: 'SET_OPPORTUNITIES_UI_FLAG',
  SET_OPPORTUNITY: 'SET_OPPORTUNITY',

  // Opportunity Pipelines
  SET_PIPELINES_UI_FLAG: 'SET_PIPELINES_UI_FLAG',
  SET_PIPELINES: 'SET_PIPELINES',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',

  // Conversation Product Labels
  SET_CONVERSATION_PRODUCT_LABELS_UI_FLAG: 'SET_CONVERSATION_PRODUCT_LABELS_UI_FLAG',
  SET_CONVERSATION_PRODUCT_LABELS: 'SET_CONVERSATION_PRODUCT_LABELS',
  SET_BULK_CONVERSATION_PRODUCT_LABELS: 'SET_BULK_CONVERSATION_PRODUCT_LABELS',

  // Conversation Topic Labels
  SET_CONVERSATION_TOPIC_LABELS_UI_FLAG: 'SET_CONVERSATION_TOPIC_LABELS_UI_FLAG',
  SET_CONVERSATION_TOPIC_LABELS: 'SET_CONVERSATION_TOPIC_LABELS',
  SET_BULK_CONVERSATION_TOPIC_LABELS: 'SET_BULK_CONVERSATION_TOPIC_LABELS',

  // Conversation Concurrent Labels
  SET_CONVERSATION_CONCURRENT_LABELS_UI_FLAG: 'SET_CONVERSATION_CONCURRENT_LABELS_UI_FLAG',
  SET_CONVERSATION_CONCURRENT_LABELS: 'SET_CONVERSATION_CONCURRENT_LABELS',
  SET_BULK_CONVERSATION_CONCURRENT_LABELS: 'SET_BULK_CONVERSATION_CONCURRENT_LABELS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_HEATMAP_DATA: 'SET_HEATMAP_DATA',
  TOGGLE_HEATMAP_LOADING: 'TOGGLE_HEATMAP_LOADING',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_CAMPAIGN_METRIC: 'SET_CAMPAIGN_METRIC',
  SET_CAMPAIGN_SUMMARY: 'SET_CAMPAIGN_SUMMARY',
  TOGGLE_CAMPAIGN_SUMMARY_LOADING: 'TOGGLE_CAMPAIGN_SUMMARY_LOADING',
  TOGGLE_CAMPAIGN_METRIC_LOADING: 'TOGGLE_CAMPAIGN_METRIC_LOADING',
  SET_ACCOUNT_CONVERSATION_METRIC: 'SET_ACCOUNT_CONVERSATION_METRIC',
  TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING',
  SET_AGENT_CONVERSATION_METRIC: 'SET_AGENT_CONVERSATION_METRIC',
  SET_TEAM_CONVERSATION_METRIC: 'SET_TEAM_CONVERSATION_METRIC',
  SET_INBOX_CONVERSATION_METRIC: 'SET_INBOX_CONVERSATION_METRIC',
  TOGGLE_AGENT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_AGENT_CONVERSATION_METRIC_LOADING',
  TOGGLE_INBOX_CONVERSATION_METRIC_LOADING:
    'TOGGLE_INBOX_CONVERSATION_METRIC_LOADING',
  TOGGLE_TEAM_CONVERSATION_METRIC_LOADING:
    'TOGGLE_TEAM_CONVERSATION_METRIC_LOADING',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Scheduled Messages
  SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG: 'SET_SCHEDULED_MESSAGES_TEMPLATE_UI_FLAG',
  SET_SCHEDULED_MESSAGE: 'SET_SCHEDULED_MESSAGE',
  ADD_SCHEDULED_MESSAGES: 'ADD_SCHEDULED_MESSAGES',
  DELETE_SCHEDULED_MESSAGES: 'DELETE_SCHEDULED_MESSAGES',
  SET_BLOCKED_SEND_TEMPLATES: 'SET_BLOCKED_SEND_TEMPLATES',

  // History Closing Reasons
  SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG: 'SET_HISTORY_CLOSING_REASONS_TEMPLATE_UI_FLAG',
  SET_HISTORY_CLOSING_REASONS: 'SET_HISTORY_CLOSING_REASONS',
  ADD_HISTORY_CLOSING_REASONS: 'ADD_HISTORY_CLOSING_REASONS',

  // History Ctwa Campaigns
  SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG: 'SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG',
  SET_HISTORY_CTWA_CAMPAIGNS: 'SET_HISTORY_CTWA_CAMPAIGNS',
  ADD_HISTORY_CTWA_CAMPAIGNS: 'ADD_HISTORY_CTWA_CAMPAIGNS',

  // Closing Reasons
  SET_CLOSING_REASONS_TEMPLATE_UI_FLAG: 'SET_CLOSING_REASONS_TEMPLATE_UI_FLAG',
  SET_CLOSING_REASONS: 'SET_CLOSING_REASONS',
  ADD_CLOSING_REASONS: 'ADD_CLOSING_REASONS',
  DELETE_CLOSING_REASONS: 'DELETE_CLOSING_REASONS',

  // Template Parameterizations
  SET_PARAMETERIZATION_UI_FLAG: 'SET_PARAMETERIZATION_UI_FLAG',
  ADD_PARAMETERIZATION: 'ADD_PARAMETERIZATION',
  EDIT_PARAMETERIZATION: 'EDIT_PARAMETERIZATION',
  SET_PARAMETERIZATIONS: 'SET_PARAMETERIZATIONS',
  DELETE_PARAMETERIZATION: 'DELETE_PARAMETERIZATION',

  //Inbox Closing Reasons
  SET_INBOX_REASONS_UI_FLAG: 'SET_INBOX_REASONS_UI_FLAG',
  SET_INBOX_REASONS: 'SET_INBOX_REASONS',
  EDIT_INBOX_REASONS: 'EDIT_INBOX_REASONS',

  // WEBHOOKS_SEND_MESSAGES
  SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG: 'SET_WEBHOOKS_SEND_MESSAGES_TEMPLATE_UI_FLAG',
  SET_WEBHOOKS_SEND_MESSAGES: 'SET_WEBHOOKS_SEND_MESSAGES',
  ADD_WEBHOOKS_SEND_MESSAGES: 'ADD_WEBHOOKS_SEND_MESSAGES',
  DELETE_WEBHOOKS_SEND_MESSAGES: 'DELETE_WEBHOOKS_SEND_MESSAGES',

  //Inbox Closing Reasons
  SET_OBSERVER_MODE: 'SET_OBSERVER_MODE',

  // Templates
  SET_TEMPLATE_UI_FLAG: 'SET_TEMPLATE_UI_FLAG',
  SET_TEMPLATE_SYNC: 'SET_TEMPLATE_SYNC',
  SET_TEMPLATES: 'SET_TEMPLATES',
  ADD_TEMPLATE: 'ADD_TEMPLATE',
  DELETE_TEMPLATE: 'DELETE_TEMPLATE',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  SET_META: 'SET_META',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',
  SET_CAMPAIGN_FILE_ANALYSIS_UI_FLAG: 'SET_CAMPAIGN_FILE_ANALYSIS_UI_FLAG',
  SET_CAMPAIGN_FILE_ANALYSIS: 'SET_CAMPAIGN_FILE_ANALYSIS',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',

  // Automations
  SET_AUTOMATION_UI_FLAG: 'SET_AUTOMATION_UI_FLAG',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  EDIT_AUTOMATION: 'EDIT_AUTOMATION',
  DELETE_AUTOMATION: 'DELETE_AUTOMATION',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  UPDATE_CUSTOM_VIEW: 'UPDATE_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',

  // Bulk Actions
  SET_BULK_ACTIONS_FLAG: 'SET_BULK_ACTIONS_FLAG',

  // Bulk Actions Settings
  SET_BULK_ACTIONS_SETTINGS_UI_FLAG: 'SET_BULK_ACTIONS_SETTINGS_UI_FLAG',
  SET_BULK_ACTIONS_SETTINGS: 'SET_BULK_ACTIONS_SETTINGS',
  ADD_BULK_ACTIONS_SETTINGS: 'ADD_BULK_ACTIONS_SETTINGS',
  EDIT_BULK_ACTIONS_SETTINGS: 'EDIT_BULK_ACTIONS_SETTINGS',
  DELETE_BULK_ACTIONS_SETTINGS: 'DELETE_BULK_ACTIONS_SETTINGS',
  SET_BULK_ACTIONS_SETTINGS_PREVIEW: 'SET_BULK_ACTIONS_SETTINGS_PREVIEW',
  SET_BULK_ACTIONS_SETTINGS_REPORT: 'SET_BULK_ACTIONS_SETTINGS_REPORT',

  // Dashboard Apps
  SET_DASHBOARD_APPS_UI_FLAG: 'SET_DASHBOARD_APPS_UI_FLAG',
  SET_DASHBOARD_APPS: 'SET_DASHBOARD_APPS',
  CREATE_DASHBOARD_APP: 'CREATE_DASHBOARD_APP',
  EDIT_DASHBOARD_APP: 'EDIT_DASHBOARD_APP',
  DELETE_DASHBOARD_APP: 'DELETE_DASHBOARD_APP',

  // Help center
  ADD_ARTICLE: 'ADD_ARTICLE',
  ADD_ARTICLE_ID: 'ADD_ARTICLE_ID',
  ADD_MANY_ARTICLES: 'ADD_MANY_ARTICLES',
  ADD_MANY_ARTICLES_ID: 'ADD_MANY_ARTICLES_ID',
  SET_ARTICLES_META: 'SET_ARTICLES_META',
  UPDATE_ARTICLE_FLAG: 'UPDATE_ARTICLE_FLAG',
  ADD_ARTICLE_FLAG: 'ADD_ARTICLE_FLAG',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  CLEAR_ARTICLES: 'CLEAR_ARTICLES',
  REMOVE_ARTICLE: 'REMOVE_ARTICLE',
  REMOVE_ARTICLE_ID: 'REMOVE_ARTICLE_ID',
  SET_UI_FLAG: 'SET_UI_FLAG',

  // Help Center -- Categories
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_ID: 'ADD_CATEGORY_ID',
  ADD_MANY_CATEGORIES: 'ADD_MANY_CATEGORIES',
  ADD_MANY_CATEGORIES_ID: 'ADD_MANY_CATEGORIES_ID',
  ADD_CATEGORY_FLAG: 'ADD_CATEGORY_FLAG',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_CATEGORY_ID: 'REMOVE_CATEGORY_ID',

  // Agent Bots
  SET_AGENT_BOT_UI_FLAG: 'SET_AGENT_BOT_UI_FLAG',
  SET_AGENT_BOTS: 'SET_AGENT_BOTS',
  ADD_AGENT_BOT: 'ADD_AGENT_BOT',
  EDIT_AGENT_BOT: 'EDIT_AGENT_BOT',
  DELETE_AGENT_BOT: 'DELETE_AGENT_BOT',
  SET_AGENT_BOT_INBOX: 'SET_AGENT_BOT_INBOX',
  SET_AGENT_BOT_INBOX_OPTION: 'SET_AGENT_BOT_INBOX_OPTION',

  // Bots
  SET_BOT_UI_FLAG: 'SET_BOT_UI_FLAG',
  SET_BOTS: 'SET_BOTS',
  DELETE_BOT: 'DELETE_BOT',

  // MACROS
  SET_MACROS_UI_FLAG: 'SET_MACROS_UI_FLAG',
  SET_MACROS: 'SET_MACROS',
  ADD_MACRO: 'ADD_MACRO',
  EDIT_MACRO: 'EDIT_MACRO',
  DELETE_MACRO: 'DELETE_MACRO',

  // Full Search
  FULL_SEARCH_SET: 'FULL_SEARCH_SET',
  CONTACT_SEARCH_SET: 'CONTACT_SEARCH_SET',
  CONTACT_SEARCH_SET_UI_FLAG: 'CONTACT_SEARCH_SET_UI_FLAG',
  CONVERSATION_SEARCH_SET: 'CONVERSATION_SEARCH_SET',
  CONVERSATION_SEARCH_SET_UI_FLAG: 'CONVERSATION_SEARCH_SET_UI_FLAG',
  MESSAGE_SEARCH_SET: 'MESSAGE_SEARCH_SET',
  MESSAGE_SEARCH_SET_UI_FLAG: 'MESSAGE_SEARCH_SET_UI_FLAG',
  FULL_SEARCH_SET_UI_FLAG: 'FULL_SEARCH_SET_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS_UI_FLAG:
    'SET_CONVERSATION_PARTICIPANTS_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS: 'SET_CONVERSATION_PARTICIPANTS',

  // Audit Logs
  SET_AUDIT_LOGS_UI_FLAG: 'SET_AUDIT_LOGS_UI_FLAG',
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  SET_AUDIT_LOGS_META: 'SET_AUDIT_LOGS_META',

  // Webhooks Send Messages Logs
  SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG: 'SET_WEBHOOKS_SEND_MESSAGES_LOGS_UI_FLAG',
  SET_WEBHOOKS_SEND_MESSAGES_LOGS: 'SET_WEBHOOKS_SEND_MESSAGES_LOGS',
  SET_WEBHOOKS_SEND_MESSAGES_LOGS_META: 'SET_WEBHOOKS_SEND_MESSAGES_LOGS_META',

  SET_POLICIES_ACCESS_ACCOUNT_DATE_EXPIRES: 'SET_POLICIES_ACCESS_ACCOUNT_DATE_EXPIRES',

  // CADENCIAS
  SET_CADENCIAS_UI_FLAG: 'SET_CADENCIAS_UI_FLAG',
  SET_CADENCIAS: 'SET_CADENCIAS',
  ADD_CADENCIA: 'ADD_CADENCIA',
  EDIT_CADENCIA: 'EDIT_CADENCIA',
  DELETE_CADENCIA: 'DELETE_CADENCIA',

  // SYONET CONNECTIONS
  SET_SYONET_CONNECTIONS_UI_FLAG: 'SET_SYONET_CONNECTIONS_UI_FLAG',
  SET_SYONET_CONNECTIONS: 'SET_SYONET_CONNECTIONS',
  ADD_SYONET_CONNECTION: 'ADD_SYONET_CONNECTION',
  EDIT_SYONET_CONNECTION: 'EDIT_SYONET_CONNECTION',
  DELETE_SYONET_CONNECTION: 'DELETE_SYONET_CONNECTION',

  // EVENTS
  SET_EVENTS_UI_FLAG: 'SET_EVENTS_UI_FLAG',
  SET_EVENTS: 'SET_EVENTS',
  ADD_EVENT: 'ADD_EVENT',
  EDIT_EVENT: 'EDIT_EVENT',
  DELETE_EVENT: 'DELETE_EVENT',

  // CALL
  SET_CALL_UI_FLAG: 'SET_CALL_UI_FLAG',
  SET_CALL_SETTINGS: 'SET_CALL_SETTINGS',

  // OPPORTUNITY PIPELINES
  SET_OPPORTUNITY_PIPELINES_UI_FLAG: 'SET_OPPORTUNITY_PIPELINES_UI_FLAG',
  SET_OPPORTUNITY_PIPELINES: 'SET_OPPORTUNITY_PIPELINES',
  ADD_OPPORTUNITY_PIPELINE: 'ADD_OPPORTUNITY_PIPELINE',
  EDIT_OPPORTUNITY_PIPELINE: 'EDIT_OPPORTUNITY_PIPELINE',

  // OPERATIONAL DASHBOARD
  SET_OPERATIONAL_DASHBOARD_UI_FLAG: 'SET_OPERATIONAL_DASHBOARD_UI_FLAG',
  SET_OPERATIONAL_DASHBOARD_DATA: 'SET_OPERATIONAL_DASHBOARD_DATA',
  SET_ACTIVITY_AGENDA_SUMMARY: 'SET_ACTIVITY_AGENDA_SUMMARY',
};
